import { useState } from 'react'

import { DSInput, DSSpinner } from '@vr/ds-react'

import { Button } from './styled'
import { useCardPost } from '@/hooks/use-card-post'

const EditableText = ({
  collectId,
  unit
}: {
  collectId: string
  unit: {
    cpf: string
    idOperadora: string
    idUnidade: string
    numeroCartao: string
  }
}) => {
  const { cpf, idOperadora, idUnidade, numeroCartao } = unit
  const [isEditing, setIsEditing] = useState(false)
  const [text, setText] = useState(numeroCartao)
  const [icon, setIcon] = useState('principal-edit')

  const { cardPost, isLoading } = useCardPost()

  const handleTextClick = () => {
    setIsEditing(true)
  }

  const handleInputChange = event => {
    setText(event.target.value)
  }

  const handleInputBlur = async () => {
    setIsEditing(false)

    const response = await cardPost({
      id: collectId,
      idOperadora,
      idUnidade,
      cpf,
      numeroCartao: text
    })

    if (response?.sucesso) {
      setIcon('principal-check')
    } else {
      setIcon('principal-error')
    }

    setTimeout(() => {
      setIcon('principal-edit')
    }, 3000)
  }

  return (
    <div style={{ display: 'inline-flex', justifyContent: 'center' }}>
      {isEditing ? (
        <DSInput
          type='number'
          value={text}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          autoFocus
          rightIcon='principal-check'
          maxLength={5}
        />
      ) : isLoading ? (
        <DSSpinner size='extraLarge' />
      ) : (
        <Button iconRight={icon} onClick={handleTextClick} size='small'>
          {text}
        </Button>
      )}
    </div>
  )
}

export default EditableText
